import { render, staticRenderFns } from "./ReferencedModel.vue?vue&type=template&id=34a30182&scoped=true&"
import script from "./ReferencedModel.vue?vue&type=script&lang=ts&"
export * from "./ReferencedModel.vue?vue&type=script&lang=ts&"
import style0 from "./ReferencedModel.vue?vue&type=style&index=0&id=34a30182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a30182",
  null
  
)

export default component.exports